export default __webpack_public_path__ + "static/media/LinkedIn Learning Network+ Prep 7 Wireless, Virtual, Cloud, And Mobile Networking.eca09aa0.webp";